import { createContext } from "react";

export const OnboardingEntryPathContext = createContext<string | null>(null);
